<script lang="ts">
    export let value: any;
    export let label: string;
    export let className = null;
</script>

<div class="naui-field active {className}">
    <div class="naui-field-back fill">
        <label class="focus">{label}</label>
        <div class="naui-input w-100 pt-8rem">
            {value}
        </div>
    </div>
</div>